<app-insights-library__item-selector-shell
  [actions]="itemSelectorActions"
  [selectors]="itemSelectorSelectors"

  [user]="user"
  [busy]="busy"

  (categorySelected)="categorySelected.emit($event)"
  (itemSelected)="itemSelected.emit($event)">

  <ng-template app-insights-library__item-selector__item-actions let-item="item">
    <button trgButton color="primary" class="h-30 lh-30 min-w-100 text-left px-12" [disabled]="busy || !item?.canView" (click)="view(item)">
      <i class="fal fa-desktop i-12 mr-6"></i>
      <span>View</span>
    </button>

    <button trgButton color="primary" class="h-30 lh-30 min-w-100 text-left ml-15 px-12" [disabled]="busy || !item?.canCopy" (click)="copy(item)">
      <i class="fal fa-copy i-12 mr-6"></i>
      <span>Copy to My Visuals</span>
    </button>

    <button trgButton color="outline" class="h-30 lh-30 min-w-100 text-left ml-15 px-12"
            [ngClass]="{'bgc-grey-5 bc-grey-5 c-white': item?.visual.home}"
            [disabled]="busy" (click)="addToHome(item)">
      <i class="fas fa-home i-14 mr-4 i-circle bgc-grey-14 text-center"
         [ngClass]="{'bgc-white c-grey-5': item?.visual.home}"></i>
      <span>Add to Home</span>
    </button>

    <div class="suggest-insight c-blue fs-14 bold">
      <a href="{{ suggestAnInsightMailTo }}"><i class="fas fa-analytics"></i> Suggest an Insight!</a>
    </div>
  </ng-template>

  <ng-template app-insights-library__item-selector__item-description let-item="item" let-visual="item?.visual">
    <ng-container *ngIf="item">
      <div class="d-flex justify-content-between">
        <div class="fs-16 c-blue bold text-ellipsis ws-pre-line line-clamp-2 pr-8 align-self-center" [title]="visual.name" style="width:305px;">
          {{visual.name}}
        </div>
        <div class="align-self-start" style="flex: 0 0 65px">
          <button trgButton color="grey-14" class="trg-toggle min-w-24 size-24 lh-28 br-round mr-8"
                  [class.in]="false"
                  (click)="favourite(item)" click-stop-propagation
                  [disabled]="busy">
            <i *ngIf="!item.favourite" class="far fa-star i-14"></i>
            <i *ngIf="item.favourite" class="fas fa-star i-14"></i>
          </button>

          <button *ngIf="item.canView || item.canCopy"
                  trgButton color="grey-14" class="min-w-24 size-24 lh-28 br-round mr-8" [matMenuTriggerFor]="menu"
                  click-stop-propagation
                  [disabled]="busy">
            <i class="fas fa-ellipsis-v i-12"></i>
          </button>
          <mat-menu #menu="matMenu">
            <button *ngIf="item.canView" mat-menu-item (click)="view(item)" [disabled]="busy">
              <i class="fal fa-desktop mr-6"></i>
              <span>View</span>
            </button>
            <button *ngIf="item.canCopy" mat-menu-item (click)="copy(item)" [disabled]="busy">
              <i class="fal fa-copy mr-6"></i>
              <span>Copy to My Visuals</span>
            </button>
          </mat-menu>
        </div>
      </div>
      <hr />
      <div class="fs-12 c-text-dark-grey">
        @if (visual.subtitle) {
          <div class="mb-15">
            <h5 class="m-0 bold">Subtitle</h5>
            <p class="m-0 ml-5 mt-5 fs-12" [title]="visual.subtitle">
              {{visual.subtitle}}
            </p>
          </div>
        }
        <div>
          <h5 class="m-0 bold">Description</h5>
          <p class="m-0 ml-5 mt-5 fs-12" [title]="visual.description">
            {{visual.description}}
          </p>
        </div>
        <div class="mt-15">
          <h5 class="m-0 bold">Categories</h5>
          <div class="m-0 ml-5 mt-5 fs-12" [class.two-column-grid]="item.categories.length > 5">
            <span *ngFor="let category of item.categories; last as last" [title]="category">{{category}}<span *ngIf="!last" class="comma">, </span></span>
          </div>
        </div>
        <div class="mt-15">
          <h5 class="m-0 bold">Type</h5>
          <p class="m-0 ml-5 mt-5 fs-12" [title]="item.chartType.title">{{item.chartType.title}}</p>
        </div>
        <div class="mt-15">
          <h5 class="m-0 bold">Dataset</h5>
          <p class="m-0 ml-5 mt-5 fs-12" [title]="visual.schemaName">{{visual.schemaName}}</p>
        </div>
        <div class="mt-15" *ngIf="item.fields?.length">
          <h5 class="m-0 bold">Fields</h5>
          <div class="m-0 ml-5 mt-5 fs-12" [class.two-column-grid]="item.fields.length > 5">
            <span *ngFor="let field of item.fields; last as last; index as index">
            @let fieldText = formatFieldTitle(item, index);
            <span [title]="fieldText">{{fieldText}}</span>
            <span *ngIf="!last" class="comma">, </span></span>
          </div>
        </div>
        <div class="mt-15">
          <h5 class="m-0 bold">Filters</h5>
          <div class="m-0 ml-5 mt-5 fs-12" [class.two-column-grid]="item.filters.length > 5">
            <span *ngFor="let filter of item.filters; last as last; index as index">
              @let filterText = formatFilter(item, index);
              <span [innerHTML]="filterText" [title]="filterText"></span>
              <span *ngIf="!last" class="comma"><br/> </span>
            </span>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template app-insights-library__item-selector__item-preview let-item="item">
    <div *ngIf="item" class="visual-preview">
      <div class="visual-preview_wrapper">
        <div class="visual-preview__icon" style="background-image: url('{{item.chartType.previewImageUrl}}');"></div>
      </div>
    </div>
  </ng-template>

</app-insights-library__item-selector-shell>
